<template>
  <v-layout navigation>
    <div v-if="show">
      <NaturalPersonCardList :items="mine_patients" v-on:org:click="onPersonClick" />
    </div>
  </v-layout>
</template>

<script>
import VLayout from "@/layouts/Default";
import NaturalPersonCardList from "@/components/NaturalPersonCardList";

import { mapState } from "vuex";

export default {
  props: {
    to_redirect: {
      type: String,
      default: "userhome",
    },
  },
  data() {
    return {
      show: false,
      from: null,
    };
  },
  fallbackI18n: {
    messages: {
      und: {
        refund_patient_selection: {
          error: {
            retrieving_patients: "Cannot load patients",
          },
        },
      },
    },
  },
  computed: {
    ...mapState({
      mine_patients: state => state.naturalperson.mine_patients,
    }),
  },
  mounted: function() {
    this.$store.dispatch("naturalperson/REQUEST_PATIENT").then(
      () => {
        if (this.mine_patients.length == 1) {
          history.replaceState({}, this.from.name, this.from.path);
          this.$router.push({
            name: this.to_redirect,
            params: {
              pt_uuid: this.mine_patients[0].uuid,
            },
          });
        } else if (this.mine_patients.length <= 0) {
          history.replaceState({}, this.from.name, this.from.path);
          this.$router.push({
            name: "patientdata",
          });
        } else {
          this.show = true;
        }
      },
      err => {
        this.$sentry({ capture: err });
        this.mnotify_error({
          text: this.$t("refund_patient_selection.error.retrieving_patients"),
        });
      }
    );
  },
  methods: {
    onPersonClick: function(item) {
      this.$router.push({
        name: this.to_redirect,
        params: {
          pt_uuid: item.uuid,
        },
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from = from;
    });
  },
  components: {
    VLayout,
    NaturalPersonCardList,
  },
};
</script>

<style>
</style>
